import React from "react";
import { Button, Card, Checkbox, Col, Divider, Modal, Row, Image, Tooltip, Tag } from 'antd';
import { CloseOutlined, MoreOutlined } from '@ant-design/icons';
import { InfoCircleOutlined } from "@ant-design/icons";
import moment from "moment";

export const contentAreaStyle = {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "flex-start",
    flex: 1,
    marginRight: "20px",
    minHeight: "400px",
    height: "400px",
    overflowY: "auto",
    overflowX: "hidden",
    minWidth: "200px",
};

export const colCardStyle = {
    display: "flex",
    minWidth: "280px",
    flex: 1,
    marginBottom: "16px",
    // maxWidth: "300px"
};

export const outerCardStyle = 
    { display: 'flex',
      padding: '20px',
      flexWrap: 'wrap',
      minHeight: '400px',
      maxHeight:'500px',
      height: '450px',
      overflow: 'auto',
      overflowX: 'hidden',
      alignItems: 'center',
    //   justifyContent: 'center', 
      gap: '20px'
     }

export default function CommonCard({ data, isSelected, toggleSelect, isDisabled, setStoredPackage, storedPackage, setOpenDetail, openDetail, previewOpen, setPreviewOpen, modelName, children }) {
    return (
        <>
        <Card
            hoverable={!isDisabled}
            style={{
                flex: 1,
                border: isSelected ? "2px solid #95d5ff" : "1px solid #ddd",
                borderRadius: 12,
                padding: 0,
                display: "flex",
                flexDirection: "column",
                justifyContent: "space-between",
                minHeight: 170,
                background: isSelected ? 'linear-gradient(180deg,#9ED8FF,#23A2F7)' : 'transparent',
                opacity: isDisabled ? 0.5 : 1,
                cursor: isDisabled ? 'not-allowed' : 'pointer'

            }}
            bodyStyle={{
                padding: "12px",
                display: "flex",
                flexDirection: "column",
                flex: 1,
            }}
            onClick={() => toggleSelect(data)}
        >
            {/* {children} */}

            <div
                style={{
                    display: "flex",
                    justifyContent: "space-between",
                    alignItems: "center",
                }}
            >
                <div style={{ flex: 1, display: "flex", alignItems: "center", marginBottom: 8, gap: "15px" }}>
                    {(modelName === "session" && isDisabled) ? (
                        <Tooltip title="Already included in your selected package">
                            <InfoCircleOutlined style={{
                                color: "#1890ff",
                                fontSize: 20,
                                backgroundColor: "#e6f7ff",
                                borderRadius: "50%",
                                padding: 4,
                                cursor: "pointer"
                            }} />
                        </Tooltip>
                    ) : (
                        <Checkbox
                            checked={isSelected}
                            onChange={(e) => { e.preventDefault(), e.stopPropagation(), toggleSelect(data) }}
                            onClick={(e) => e.stopPropagation()}
                            style={{ accentColor: "green" }}
                        />
                    )}
                    <span style={{ fontWeight: 700, fontFamily: "inter", fontSize: 18 }}>{data.name}</span>
                </div>
                {modelName === "package" && <div
                    style={{ cursor: "pointer", color: "#888", fontSize: 18 }}
                >
                    <Button
                        type="text"
                        onClick={(e) => {
                            e.preventDefault(); 
                            e.stopPropagation();
                            setStoredPackage(data);
                            setOpenDetail(true);  // open the modal
                        }}
                        icon={<MoreOutlined />}
                        style={{ color: "#888" }}
                    />
                   
                </div>}
            </div>


            <div style={{ marginTop: 4 }}>
                {modelName === "session" && (
                    <>
                        <div style={{ fontSize: 12 }}>{moment(data?.start_datetime).format('MMM D, YYYY h:mm A')}</div>
                        <div style={{ fontSize: 12 }}>{moment(data?.end_datetime).format('MMM D, YYYY h:mm A')}</div>
                    </>
                )}
                <div
                    style={{ fontSize: 12, color: "#555", marginTop: 4 }}
                >
                    {data?.description}
                </div>
            </div>

            <div
                style={{
                    marginTop: "auto",
                    display: "flex",
                    justifyContent: "space-between",
                }}
            >
                <Tag color="green" style={{ fontSize: 12, fontWeight: 600 }}>
                Available
                </Tag>
                {modelName === "package" && <span style={{ fontWeight: 600 }}>
                    {data?.price === "0.00"
                        ? "FREE"
                        : `$${data?.price}`}
                </span>}
                {modelName === "session" && <span style={{ fontWeight: 600 }}>
                    {data?.base_fee === "0.00"
                        ? "FREE"
                        : `$${data?.base_fee || 0}`}
                </span>}
                 {modelName === "AddOn" && <span style={{ fontWeight: 600 }}>
                    {data?.list_price === "0.00"
                        ? "FREE"
                        : `$${data?.list_price || 0}`}
                </span>}
            </div>
            
        </Card>
         <Modal
                        title={null}
                        open={openDetail}
                        onCancel={() => { setOpenDetail(false), setStoredPackage(null) }}
                        footer={null}
                        width={"1000px"}
                        height={"auto"}
                        centered
                        closeIcon={<CloseOutlined />}
                        style={{
                            padding: 0,
                            height: 'auto',
                            borderRadius: 12,
                            maxWidth: '90vw',
                            minWidth: '300px',
                            maxHeight: '80vh',
                            overflowY: 'auto',
                            textAlign: 'left',
                            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
                            border: '1px solid #e5e5e5',
                            backgroundColor: "linear-gradient(180deg,#9ED8FF,#23A2F7)"
                        }}
                        bodyStyle={{
                            padding: 24,
                            border: '1px solid #e5e5e5',
                            borderRadius: 12,
                            boxShadow: 'none',
                            minHeight: '400px',
                            minWidth: '600px',
                        }}
                    >
                        <div style={{ display: 'flex', gap: 20 }}>
                            {storedPackage?.files?.length > 0 && storedPackage?.files[0]?.url &&<Image
                                src={storedPackage?.files[0]?.url}
                                style={{
                                    width: 140,
                                    height: 140,
                                    borderRadius: 8,
                                    objectFit: 'cover',
                                    boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
                                    marginRight: 20,
                                    border: '1px solid rgba(0,0,0,0.1)'    // thin grey outline
                                }}
                                alt=""
                                onClick={() => setPreviewOpen(true)}
                                preview={{
                                    visible: previewOpen,
                                    onVisibleChange: (v) => setPreviewOpen(v)
                                }}
                            />}
                            <div>
                                <h3
                                    style={{
                                        margin: 0,
                                        fontSize: 20,
                                        fontWeight: 700,
                                        color: '#1a1a1a'
                                    }}
                                >
                                    {storedPackage?.name}
                                </h3>
                                <div style={{ fontWeight: 500 }}>{storedPackage?.time}</div>
                                <p style={{ marginBottom: 12 }}>{storedPackage?.description}</p>
                                <p style={{ marginBottom: 4 }}><b>Included Sessions:</b></p>
                                {storedPackage?.sessions?.length > 0 ? (
                                    <ul style={{ paddingLeft: 20, margin: 0 }}>
                                        {storedPackage?.sessions?.map((session) => (
                                            <li key={session?.uuid} style={{ marginBottom: 4 }}>
                                                {session?.name} - {moment(session?.start_datetime).format('MMM D, YYYY h:mm A')} to {moment(session?.end_datetime).format('MMM D, YYYY h:mm A')}, Fee : ${session?.base_fee || 0}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div style={{ paddingLeft: 20, color: '#888' }}>No sessions included</div>
                                )}
                                <p style={{ marginBottom: 4 }}><b>Included Items:</b></p>
                                {storedPackage?.items?.length > 0 ? (
                                    <ul style={{ paddingLeft: 20, margin: 0 }}>
                                        {storedPackage?.items?.map((item) => (
                                            <li key={item?.uuid} style={{ marginBottom: 4 }}>
                                                {item?.name} - {moment(item?.start_datetime).format('MMM D, YYYY h:mm A')} to {moment(item?.end_datetime).format('MMM D, YYYY h:mm A')}, Fee : ${item?.base_fee || 0}
                                            </li>
                                        ))}
                                    </ul>
                                ) : (
                                    <div style={{ paddingLeft: 20, color: '#888' }}>No items included</div>
                                )}
                            </div>
                        </div>
            </Modal>
        </>
    )
}

